<script>
export default {
  props: ["title", "className", "hasHeaderButton", "items"],
  mounted() {
    if (this.items && this.items.length) document.title = this.items[this.items.length - 1].text;
    else document.title = this.title;
  }
};
</script>

<template>
  <div class="page-top-header d-flex align-items-center" :class="className">
    <b-breadcrumb v-if="items && items.length" :items="items"></b-breadcrumb>
    <h4 v-else class="pages-title mb-0 d-flex align-items-center">{{ title }}</h4>
    <slot v-if="true"></slot>

    <div class="header-button-wrapper" v-if="hasHeaderButton">
      <slot name="headerButton" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-top-header {
  height: 27px;
  margin-bottom: 24px;
  // margin-top: 24px;
  ol {
    background: transparent;
  }
}
.pages-title {
  color: #4a4a4a !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  //top padding for all headers
  padding-top: 0 !important;
  // padding-bottom: 24px !important;
  padding-inline-start: 24px !important;
  white-space: nowrap;
  height: 12px;
}
.header-button-wrapper {
  margin-inline-start: 40px;
  width: fit-content;
  button {
    width: 127px;
    height: 27px;
    background: #103f5e;
    border-radius: 12.5px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    border: none !important;
    color: #ffffff;
  }
}
:dir(rtl) .header-button-wrapper button {
  font-size: 14px !important;
}
</style>
